<template>
    <b-modal
        ref="dialog"
        lazy
        title-tag="h2"
        title="Extend Stay"
        footer-class="d-flex"
        @show="$emit('loaded')"
        no-close-on-backdrop
        no-close-on-esc
    >
        <b-form-group
            label-cols="3"
            label="Room:"
            label-for="room"
            class="mb-0"
        >
            <b-form-input plaintext :value="room"></b-form-input>
        </b-form-group>
        <b-form-group
            label-cols="3"
            label="Client:"
            label-for="client"
            class="mb-0"
        >
            <b-form-input plaintext :value="client"></b-form-input>
        </b-form-group>
        <b-form-group
            label-cols="3"
            label="Guest:"
            label-for="guest"
            class="mb-0"
        >
            <b-form-input plaintext :value="guest"></b-form-input>
        </b-form-group>
        <b-form-group
            label-cols="3"
            label="Check In:"
            label-for="checkin"
            class="mb-0"
        >
            <b-form-input plaintext :value="checkin"></b-form-input>
        </b-form-group>
        <b-form-group
            label-cols="3"
            label="Check Out:"
            label-for="checkout"
            class="mb-0"
        >
            <!-- <input type="date" class="form-control" v-model="checkout" /> -->
            <date-picker
                name="checkout"
                :config="datePickerOptionsCheckOut"
                v-model="checkout"
                placeholder="Check-out date"
                @dp-change="value => setCheckoutDate(value)"
            />
        </b-form-group>
        <b-form-group
            v-if="notes && notes !== ''"
            label-cols="3"
            label="Notes:"
            label-for="notes"
            class="mb-0"
        >
            <b-form-input plaintext :value="notes"></b-form-input>
        </b-form-group>
        <template v-slot:modal-footer="{ close }">
            <loader v-if="isSaving" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isSaving"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isSaving"
                variant="primary"
                @click="save"
                :disabled="momentCheckOut === null"
            >
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import BoardingService from "@/services/boarding.js";
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    data() {
        return {
            boardingId: null,
            room: "--",
            client: "--",
            guest: "--",
            checkin: "--",
            checkout: null,
            notes: "",
            isSaving: false,
            datePickerOptionsCheckOut: {},
            momentCheckOut: null
        };
    },
    methods: {
        setCheckoutDate(value) {
            this.momentCheckOut = value.date;
        },
        async open(id) {
            let details = await BoardingService.getBoardingById(id);

            let dateFormat = this.getDateFormat();
            let momentCheckIn = moment.unix(details.start).tz(this._timeZone);
            let momentCheckOut = moment.unix(details.end).tz(this._timeZone);

            let notes = "";
            if (details.note && details.note !== "") {
                notes = details.note;
            }

            this.boardingId = id;
            this.room = details.room ? details.room.name : "--";
            this.client = details.client ? details.client.label : "--";
            this.guest = details.patient ? details.patient.name : "--";
            this.checkin = momentCheckIn.format(dateFormat);
            this.checkout = momentCheckOut.toDate();
            this.notes = notes;

            this.datePickerOptionsCheckOut = {
                format: dateFormat,
                timeZone: this._timeZone
            };

            this.$refs.dialog.show();
        },
        async save() {
            try {
                this.isSaving = true;

                let boardingSettings = await BoardingService.getSettings();
                let checkOutTime = boardingSettings.resource.check_out;
                let timeString = new Date(checkOutTime * 1000).toISOString().substring(11, 16); // prettier-ignore

                let dateStr = this.momentCheckOut.format("YYYY-MM-DD");
                dateStr += " " + timeString;
                let stringFormat = "YYYY-MM-DD HH:mm";
                let momentDate = moment.tz(dateStr, stringFormat, this._timeZone); // prettier-ignore

                await BoardingService.extendStay({
                    id: this.boardingId,
                    end: momentDate.unix()
                });

                this.$refs.dialog.hide();
                this._message("Reservation has been updated.");
                this.$emit("success", this.boardingId);
            } catch (error) {
                this.isSaving = false;
                this._message(error.message, "danger");
            }
        }
    }
};
</script>
